<template>
  <router-view />
</template>

<script>
export default {
  name: "app-udTable"
};
</script>

<style lang="scss" scoped></style>
